import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: 'hosts',
      method: 'get',
      request: id => ({ url: apiRoutes.hosts(id) }),
    },
  ])(ComposedComponent);
